import { BasicInfoState } from "app/pages/DiscountEditor/modules/BasicInfo/state";
import { Action, ActionType } from "app/pages/DiscountEditor/actionTypes";
import { DiscountType } from "app/shared/model/DiscountType";

const startingState : BasicInfoState = {
    publicName: '', 
    internalName: '', 
    discountType: DiscountType.marketDiscount,
    description: '',
    promotionCode: ''
}

export function reducer(state: BasicInfoState|undefined, action: Action) : BasicInfoState {
    if (!state) {
        return startingState;
    }

    switch(action.type) {
        case ActionType.PageLoaded:
            const discount = action.discount.basicDetails;
            const promo = discount as { PromotionCode?: string | null; promotionCode?: string | null };
            return {
                publicName: discount.publicName,
                internalName: discount.internalName,
                discountType: discount.discountType,
                description: discount.description,
                promotionCode: promo.PromotionCode ?? promo.promotionCode ?? ''
            };

        case ActionType.ChangePublicName: 
            return Object.assign({}, state, { publicName: action.value }); 
        case ActionType.ChangeInternalName: 
            return Object.assign({}, state, { internalName: action.value }); 
        case ActionType.ChangeDescription: 
            return Object.assign({}, state, { description: action.value }); 
        case ActionType.ChangeDiscountType:
            return Object.assign({}, state, {
                discountType: action.discountType,
                promotionCode:
                    action.discountType === DiscountType.specialOffer ? state.promotionCode : ''
            });
        case ActionType.ChangePromotionCode:
            return Object.assign({}, state, { promotionCode: action.value });
        default:
            return state;
    }
}

